import { Button } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import ProductForm from "components/form/ProductForm";

import { SaveContextProvider } from "context/save";

import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Prodotto creato con successo",
        errorMsg: "Errore nella creazione del prodotto",
        navigateTo: { link: "/gestione-prodotti/prodotti/:productId/modifica", id: "productId" },
    });

    return (
        <GridItem>
            <GridRow justifyContent={"right"}>
                <GridItem>
                    <Button variant={"contained"} onClick={onButtonClick}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

function NuovoProdotto() {
    return (
        <GridColumn className={"product-page"}>
            <SaveContextProvider>
                <GridItem>
                    <GridRow justifyContent={"space-between"} alignItems={"end"}>
                        <GridItem>
                            <GridRow>
                                <GridItem>
                                    <h1>Aggiungi Prodotto</h1>
                                </GridItem>
                            </GridRow>
                        </GridItem>

                        <GridItem>
                            <ButtonSave />
                        </GridItem>
                    </GridRow>
                </GridItem>

                <ProductForm />
            </SaveContextProvider>
        </GridColumn>
    );
}

export default NuovoProdotto;
